import BordOneToneIcon from 'components/NudosComponents/BordOneToneIcon/BordOneToneIcon';
import { IBulkUploadLoadStatus } from '../../TypeOfCharge.types';
import './LoadStatus.scss';

const LoadStatus = ({ success, total, typeOfCharge }: IBulkUploadLoadStatus) => {
  const iconLoadStatus =
    success === total ? (
      <BordOneToneIcon variant="checkCircle" customWidth="12px" stroke="#81BC3F" />
    ) : (
      <BordOneToneIcon variant="alertTriangleWarning" customWidth="12px" stroke="#FB0" />
    );
  return (
    <div className="loadStatusComponent">
      {iconLoadStatus}
      <span>
        {success || 0}/{total || 0} {typeOfCharge}
      </span>
    </div>
  );
};

export default LoadStatus;
